import { borderRadius, styles } from '@/common/style';
import React, { useEffect, useRef, useState } from 'react';
import { StyleProp, View, ViewStyle, TextInput, Keyboard } from 'react-native';
import { ButtonWrapper } from '@/component/Button/Button';
import iconPlus from '@/assets/icon/icon_stepper_plus.png';
import iconPlusDisabled from '@/assets/icon/icon_stepper_plus_2.png';
import iconMinus from '@/assets/icon/icon_stepper_minus.png';
import iconMinusDisabled from '@/assets/icon/icon_stepper_minus_2.png';
import { KImage } from '../RtlLayout';

const Styles = {
    box: {
        value: styles({
            flexDirection: 'row',
            backgroundColor: 'rgba(242, 242, 242, 1)',
            borderRadius: 4,
            height: 24,
        }),
        left: styles({
            ...borderRadius(4, 0, 0, 4),
            borderWidth: 1,
            borderColor: 'rgba(242, 242, 242, 1)',
            width: 24,
            height: 24,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        }),
        leftDisabled: styles({
            color: '#b0afb4',
            backgroundColor: 'rgba(200, 200, 200, 0.24)',
        }),
        input: styles({
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: 'rgba(242, 242, 242, 1)',
            width: 40,
            height: 24,
            lineHeight: 16.4,
            fontSize: 14,
            fontWeight: '500',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#000',
            paddingVertical: 0,
            backgroundColor: '#fff',
        }),
        right: styles({
            ...borderRadius(0, 4, 4, 0),
            borderWidth: 1,
            borderColor: 'rgba(242, 242, 242, 1)',
            width: 24,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
        }),
        rightDisabled: styles({
            color: '#b0afb4',
            backgroundColor: 'rgba(200, 200, 200, 0.24)',
        }),
    },
};

export function Stepper(props: {
    style?: StyleProp<ViewStyle>;
    value: number;
    disablePlus?: boolean;
    disableMinus?: boolean;
    disable?: boolean;
    onPlus?: Function;
    disableText?: boolean;
    onMinus?: Function;
    onBlur?: Function;
    onChange?: Function;
    onOverLimit?: (type?: 'minus' | 'plus') => void;
    min?: number;
    max?: number;
    fallbackWhenEmpty?: boolean;
    onlyBlurTriggerChange?: boolean;
}) {
    const {
        style = {},
        value = 0,
        onMinus = console.log,
        onPlus = console.log,
        onBlur = console.log,
        onChange = console.log,
        onOverLimit = console.log,
        disableMinus = false,
        disablePlus = false,
        disable = false,
        disableText = false,
        min,
        max,
        fallbackWhenEmpty = false,
        onlyBlurTriggerChange = false,
    } = props;

    const isMinusDisabled = value <= min || disableMinus;
    const isPlusDisabled = value >= max || disablePlus;

    const [editingValue, setEditingValue] = useState<any>(value);
    const inputRef = useRef<TextInput>(null);
    useEffect(() => {
        setEditingValue(props.value);
    }, [props.value]);

    useEffect(() => {
        function onDidHide() {
            inputRef.current?.blur?.();
        }
        const sub = Keyboard.addListener('keyboardDidHide', onDidHide);
        return () => {
            sub.remove();
        };
    }, []);

    return (
        <View style={[Styles.box.value, style]}>
            <ButtonWrapper
                onPress={() => {
                    if (disable) return;
                    if (props.value > max) {
                        onMinus(Number(max)); // 初始值大于max值时，点击-按钮，直接减少到max值
                        return;
                    }
                    if (!isMinusDisabled) onMinus(Number(editingValue) - 1);
                    else onOverLimit('minus');
                }}
                // 设计说用新的disable，from 购物车设计稿
                style={[Styles.box.left]}
                // style={[Styles.box.left, isMinusDisabled || disable ? Styles.box.leftDisabled : null]}
            >
                <KImage style={styles({ width: 24, height: 24 })} source={isMinusDisabled ? iconMinusDisabled : iconMinus} />
            </ButtonWrapper>
            <TextInput
                ref={ref => (inputRef.current = ref)}
                editable={!(disable || disableText)}
                style={Styles.box.input}
                keyboardType="numeric"
                value={`${editingValue}`}
                maxLength={10}
                onBlur={() => {
                    let val = Number(editingValue);
                    if (isNaN(val)) val = min;
                    else if (val > max) {
                        val = max;
                        onOverLimit('plus');
                    } else if (val < min) {
                        val = min;
                        onOverLimit('minus');
                    }
                    setEditingValue(val);
                    if (props.value === val) return;
                    onChange(val);
                    // inputRef.current?.blur?.();
                }}
                onChangeText={text => {
                    if (onlyBlurTriggerChange) {
                        if (isNaN(+text)) {
                            return;
                        }
                        setEditingValue(text);
                        return;
                    }
                    if (text) {
                        let val = Number(text);
                        // 如果输入的不是数字， 则不让输入，即回退到上一次输入的结果
                        if (isNaN(val)) {
                            return;
                        } else if (val > max) {
                            val = max;
                            onOverLimit('plus');
                        } else if (val < min) {
                            val = min;
                            onOverLimit('minus');
                        }
                        setEditingValue(val);
                        if (props.value === val) return;
                        onChange(val);
                    } else {
                        // 如果为空，展示未空，但是不触发onChange
                        setEditingValue(text);
                        if (fallbackWhenEmpty && +text < min) {
                            onChange(min);
                        }
                        // inputRef.current?.blur?.();
                    }
                }}
            />
            <ButtonWrapper
                style={[Styles.box.right]}
                onPress={() => {
                    if (disable) return;
                    if (!isPlusDisabled) onPlus(Number(editingValue) + 1);
                    else onOverLimit('plus');
                }}>
                <KImage style={{"width":"5.797101449275363rem","height":"5.797101449275363rem"}} source={isPlusDisabled ? iconPlusDisabled : iconPlus} />
            </ButtonWrapper>
        </View>
    );
}
